import { RichText } from 'prismic-reactjs';
import classNames from 'classnames';

import { Section } from './parallax.types';
import { ParallaxSection } from './ParallaxSection';

import { useWindowSize } from '../../../../hooks/useWindowSize';
import BackButton from '../../../../styledComponents/BackButton/BackButton';
import { imageSerializer } from '../../../../utils/imageSerializer';
import Image from 'next/image';
import { ColorType } from '../../../../styledComponents/BackButton/backButton.styles';

type Props = {
  name: string;
  page: any;
  invert?: boolean;
  sections?: Section[];
  additionalClassName?: string;
  backButtonColor?: ColorType;
};

const ParallaxMainSection = ({
  name,
  page,
  invert,
  backButtonColor,
}: Props) => {
  const className = classNames(
    'parallax__section main-section',
    invert && 'parallax__section-invert'
  );
  const { width } = useWindowSize();

  return (
    <section className={className}>
      <div className="parallax__section-container">
        <div className="parallax__section-container-left">
          <BackButton
            color={backButtonColor}
            url="/services"
            label={RichText.asText(page.back_button_label)}
          />
          {width! <= 1167 && (
            <div className="parallax__section-container-image-info">
              <span className="parallax__section-container-image-info-text">
                {RichText.asText(page.page_name)}
              </span>
              <h1 className="parallax__section-container-image-info-title">
                {RichText.asText(page.page_title)}
              </h1>
            </div>
          )}
          <p className="product-design__introduction-subtitle">
            {width! >= 1168
              ? RichText.asText(page.page_subtitle)
              : ` ${RichText.asText(page.page_subtitle).replace(
                  /\.\.\./g,
                  ''
                )}`}
            {width! < 1168 &&
              ` ${RichText.asText(page.help_you_with_text).replace(
                /\.\.\./g,
                ''
              )}`}
          </p>

          <p className="parallax__section-container-left-description parallax__section-container-left-description--font-questrial">
            Discover our offering:
          </p>
        </div>
        <div className="parallax__section-container-image">
          {width! > 1167 && (
            <div className="parallax__section-container-image-info">
              <span className="parallax__section-container-image-info-text">
                {RichText.asText(page.page_name)}
              </span>
              <h1 className="parallax__section-container-image-info-title">
                {RichText.asText(page.page_title)}
              </h1>
            </div>
          )}
          <Image {...imageSerializer(page.page_image!, { inset: null })} />
        </div>
        <div className="parallax__section-container-right">
          <div />
          <p className="parallax__section-container-right-description">
            {RichText.asText(page.help_you_with_text)}
          </p>
          <span className="parallax__section-container-right-subtitle-info">
            Discover our offering:
          </span>
        </div>
      </div>
    </section>
  );
};

export const Parallax = ({
  page,
  sections,
  additionalClassName,
  invert,
  name,
  backButtonColor,
}: Props) => {
  const className = classNames('parallax', additionalClassName);
  return (
    <div className={className}>
      <ParallaxMainSection
        backButtonColor={backButtonColor}
        page={page}
        invert={invert}
        name={name}
      />
      {(sections || []).map(
        (
          { title, description, subDescription, subtitleInfo, subtitle, image },
          index
        ) => (
          <ParallaxSection
            key={`${title}-${index}`}
            title={title}
            description={description}
            subtitle={subtitle}
            subTitleInfo={subtitleInfo}
            subDescription={subDescription}
            sectionIndex={index}
            image={image}
            invert={invert}
          />
        )
      )}
    </div>
  );
};
